import React from "react";
import Collapse from "antd/lib/collapse";
import Divider from "antd/lib/divider";
import Typography from "antd/lib/typography";

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

interface VisualizationSectionProps {
    children?: React.ReactNode;
    header?: React.ReactNode;
    headerTitle: React.ReactNode;
    paragraphs: React.ReactNode[];
    descriptionsVisible: boolean;
}

export const VisualizationSection = ({
    children,
    header,
    headerTitle,
    paragraphs,
    descriptionsVisible,
}: VisualizationSectionProps) => {
    const hasChildren = React.Children.count(children) > 0;

    return (
        <section>
            {hasChildren && (
                <>
                    {descriptionsVisible && (
                        <Divider orientation="left">{header}</Divider>
                    )}
                    {children}
                </>
            )}
            {descriptionsVisible && (
                <Collapse ghost>
                    <Panel
                        key="panel"
                        header={
                            <Title
                                level={2}
                                style={{
                                    marginBottom: 0,
                                    fontSize: 14,
                                    lineHeight: 1.4,
                                }}
                            >
                                {headerTitle}
                            </Title>
                        }
                        forceRender
                    >
                        {paragraphs.map((paragraph, index) => (
                            <Paragraph key={index}>{paragraph}</Paragraph>
                        ))}
                    </Panel>
                </Collapse>
            )}
        </section>
    );
};
